import { createAppSlice } from 'app/createAppSlice'
import moment from 'moment-timezone'

const firstDay = moment().subtract(3, 'months').format('YYYY-MM-DD')
const lastDay = moment().endOf('day').format('YYYY-MM-DD')

const initialState = {
  tag: {
    size: 10,
    page: 0,
    sortby: 'createdAt',
    sortdir: 'DESC',
    s: undefined,
    start: firstDay,
    end: lastDay,
    mapped: undefined,
    hasSchema: undefined,
  },
  loading: false,
  selectedItems: {},
}

export const productMappingSchemaListSlice = createAppSlice({
  name: 'productMappingSchemaList',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
    setLoading: create.reducer((state, { payload }) => {
      state.loading = payload
    }),
    setSelectedItems: create.reducer((state, { payload }) => {
      state.selectedItems = payload
    }),
    // ...existing code...
    toggleSelectedItem: create.reducer((state, { payload }) => {
      const { item, isSelected } = payload
      if (isSelected) {
        state.selectedItems[item.id] = item
      } else {
        delete state.selectedItems[item.id]
      }
    }),
    toggleAllSelectedItems: create.reducer((state, { payload }) => {
      const { items, isSelected } = payload
      if (isSelected) {
        items.forEach((item) => {
          state.selectedItems[item.id] = item
        })
      } else {
        items.forEach((item) => {
          delete state.selectedItems[item.id]
        })
      }
    }),
    // ...existing code...
    clearSelectedItems: create.reducer((state) => {
      state.selectedItems = {}
    }),
  }),
})

export const {
  setFetchOption,
  setLoading,
  setSelectedItems,
  toggleSelectedItem,
  toggleAllSelectedItems,
  clearSelectedItems,
} = productMappingSchemaListSlice.actions

export default productMappingSchemaListSlice.reducer
